import { createApp } from 'vue'
import App from './routes/App.vue'

// This is created in its own module (outside of an entrypoint) so that
// it can be imported by other modules (e.g. app_toasted.js).
export default createApp({
  ...App
})
